import { TableComponent } from 'components/maxi-ai/tables/TableComponent';
import { TableSkeleton } from 'components/maxi-ai/tables/TableSkeleton';

import type { Artifact, ArtifactType } from 'types/maxi-ai';

interface ArtifactComponentProps {
  artifact: Artifact;
}

interface ArtifactLoadingProps {
  artifactType: ArtifactType;
}

// Loading component for different artifact types
export function ArtifactLoading({ artifactType }: ArtifactLoadingProps) {
  if (artifactType === 'table') {
    return <TableSkeleton />;
  } else {
    return (
      <div className="animate-pulse bg-gray-200 rounded-lg h-64 flex items-center justify-center">
        <div className="text-gray-500">
          Loading {artifactType.replaceAll('_', ' ')}...
        </div>
      </div>
    );
  }
}

// Main artifact component
export function ArtifactComponent({ artifact }: ArtifactComponentProps) {
  if (artifact.status === 'processing') {
    return <ArtifactLoading artifactType={artifact.type} />;
  }

  if (artifact.status === 'failed') {
    return (
      <div className="bg-red-50 border border-red-200 rounded-lg p-4">
        <div className="text-red-700 font-medium">
          Failed to load {artifact.type}
        </div>
        {artifact.error && (
          <div className="text-red-600 text-sm mt-1">{artifact.error}</div>
        )}
      </div>
    );
  }

  if (artifact.status === 'complete' && artifact.content) {
    switch (artifact.type) {
      case 'table':
        return <TableComponent tableData={artifact.content} />;
      case 'line_chart':
        return (
          <div className="bg-gray-50 border border-gray-200 rounded-lg p-4">
            <div className="text-gray-700">Line Chart (Coming Soon)</div>
            <pre className="text-xs text-gray-500 mt-2 overflow-auto">
              {JSON.stringify(artifact.content, null, 2)}
            </pre>
          </div>
        );
      case 'bar_chart':
        return (
          <div className="bg-gray-50 border border-gray-200 rounded-lg p-4">
            <div className="text-gray-700">Bar Chart (Coming Soon)</div>
            <pre className="text-xs text-gray-500 mt-2 overflow-auto">
              {JSON.stringify(artifact.content, null, 2)}
            </pre>
          </div>
        );
      default:
        return (
          <div className="bg-gray-50 border border-gray-200 rounded-lg p-4">
            <div className="text-gray-700">
              Unknown artifact type: {(artifact as any).type}
            </div>
          </div>
        );
    }
  }

  return null;
}
